import { render, staticRenderFns } from "./electricitySankey.vue?vue&type=template&id=6d845823&scoped=true"
import script from "./electricitySankey.vue?vue&type=script&lang=js"
export * from "./electricitySankey.vue?vue&type=script&lang=js"
import style0 from "./electricitySankey.vue?vue&type=style&index=0&id=6d845823&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d845823",
  null
  
)

export default component.exports